package music.jammers.client.shared.component

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.format.FormatStringsInDatetimeFormats
import kotlinx.datetime.format.byUnicodePattern

@OptIn(FormatStringsInDatetimeFormats::class)
object DateFormatter {

    fun format(localDateTime: LocalDateTime, pattern: String): String {
        val dateTimeFormat = LocalDateTime.Format {
            byUnicodePattern(pattern)
        }

        return dateTimeFormat.format(localDateTime)
    }
}